import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { getAllEmployees, updateReportRestaurantId, getReport, updateReportEmployeeId, handleSelectReportBeginDate, handleSelectReportEndDate } from '../actions';
import RestaurantSelector from './RestaurantSelector';
import DateRangeSelector from './DateRangeSelector'
import Report from './Report';

const PayRollReport = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const report = useSelector(state => state.report);
    const employees = useSelector(state => state.employees)
    const restaurantId = report.restaurantId
    const [employeeID, setEmployeeID] = useState(1)
    const user = useSelector(state => state.user)
    // Only load report after clicking "Get Report" button
    // useEffect(() => {
    //     dispatch(getReport(report.restaurantId, report.beginDate, report.endDate))
    //   }, [dispatch]);
    useEffect(() => {
        dispatch(getAllEmployees(restaurantId))
      }, [dispatch, restaurantId]);
    const changeReportRestaurant = restaurantId => {
        dispatch(updateReportRestaurantId(restaurantId))
    }
    return user.RestaurantID === 0 && (
        <div className="container">
            <h1>Payroll Reports</h1>
            <button onClick={() => {
                navigate("/");
            }}>Back to Daily Records</button>
            <p/>
            <RestaurantSelector restaurantId={report.restaurantId} handleChangeRestaurant={changeReportRestaurant}/>
            <DateRangeSelector beginDate={report.beginDate} endDate={report.endDate} 
            onSelectBeginDate={date => {
                 dispatch(handleSelectReportBeginDate(date))
            }}
            onSelectEndDate={date => {
                dispatch(handleSelectReportEndDate(date))
            }}
            />
            <span><label>Employee</label></span>
            <select name="employee" id="employee" value={employeeID} onChange={e => {setEmployeeID(e.target.value); dispatch(updateReportEmployeeId(e.target.value))}} >
                {employees.map((e, i) => (
                    <option value={e.ID} key={i}>{e.Name}</option>
                ))}
            </select>
            <button onClick={()=> {
                dispatch(getReport(report.restaurantId, report.employeeTipOut.employeeId, report.beginDate, report.endDate))
            }}>Get Report</button>
            <p/>
            {report.totalSushiTipOut > 0 ?
                <Report report={report}/>:null
            }
        </div>
    )
}

export default PayRollReport